
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class ShowPopup extends Vue {
  @Prop({ default: ' ' }) readonly propTitle;
  @Prop({ default: false }) readonly propSmall;
  @Prop({ default: '70%' }) readonly propWidth;
  @Prop({ default: false }) readonly propImportant;
  @Prop({ type: Boolean, default: false }) readonly propPersistent: boolean;
  @Prop({ default: '' }) readonly propColor;
  @Prop({ default: '' }) readonly propCardText;

  public timerValue = 0;

  public timerImportant = 3; //seconds

  public dialog = false;

  public async show(show: boolean = true) {
    this.dialog = show;

    if (this.propImportant) {
      const step = 100;
      const timerStep = 100 / (this.timerImportant / (step / 1000));

      var downloadTimer = setInterval(() => {
        if (this.timerImportant <= 0) {
          clearInterval(downloadTimer);
        }
        this.timerValue += timerStep;
        this.timerImportant -= step / 1000;
      }, step);
    }
  }
}
